// Mock data pour le preview du Studio (URL ?studio=preview).
// Permet de voir le rendu sans login + sans lancer une analyse.

export const STUDIO_MOCK_SESSION = {
  id: 'preview-mock',
  ig_username: 'stephanie_hypno',
  status: 'done',
  progress_pct: 100,
  persona: {
    niche_fine: 'Hypnothérapie B2C pour cadres en burn-out',
    audience_cible: "Cadres et entrepreneurs entre 30 et 50 ans qui n'arrivent plus à décrocher, dorment mal, et cherchent une alternative aux médicaments sans passer par la psychothérapie classique.",
    ton_voix: 'Calme, ancrée, vulnérable. Parle de ses propres galères avant celles des autres.',
    douleurs: [
      "S'endormir avec le cerveau qui tourne en boucle",
      "Avoir l'impression d'être en train de craquer mais devoir continuer",
      'Se sentir seul·e à ne pas y arriver alors que tout le monde semble gérer',
    ],
    desirs: [
      'Retrouver un sommeil profond sans somnifères',
      'Pouvoir poser la charge mentale même 30 minutes par jour',
      "Comprendre d'où vient leur stress sans 5 ans de thérapie",
    ],
    vocabulaire: [
      'je galère',
      "j'arrive plus à dormir",
      'je suis épuisée',
      "j'ai essayé tout",
      "ça n'a rien donné",
      "j'avais besoin d'un déclic",
    ],
    blocages: [
      "Pas d'offre claire en bio",
      'Hooks trop doux qui ne provoquent pas de scroll-stop',
      'Pas de preuve sociale visible (témoignages clients)',
    ],
  },
  formats: [
    // === 3 FREE ===
    {
      format_id: 'mock-1',
      locked: false,
      source: {
        createur: '@dan_koe',
        niche: 'Solopreneur',
        format_nom: 'Monologue face caméra · cadrage serré',
        vues: 2_140_000,
        engagement: 4.2,
        duree_secondes: 38,
        lien: 'https://www.instagram.com/reel/DXYZ123abc/',
        poster_url: null,
        mecanisme_viral: 'Confession',
        arc_narratif: 'Problème → Solution',
        emotion_primaire: 'Vulnérabilité',
        hook_original: "Most people work hard at the wrong thing. Here's the question that changed everything for me.",
        script_original: "Most people work hard at the wrong thing.\n\nFor years I optimized my productivity, my schedule, my output. Result : burnout at 28.\n\nThe question that saved me : what would a calm version of me do right now ?\n\nThat single question reorganized my entire work day.\n\nNot more discipline. More clarity.",
      },
      hook_template: "La plupart des gens [Action quotidienne] alors qu'ils devraient [Action alternative]. La question qui a tout changé pour moi.",
      hook_adapted: "La plupart de mes clients essaient de mieux dormir alors qu'ils devraient apprendre à mieux décrocher. La question qui a tout changé pour Camille.",
      script_template: "La plupart [Audience cible] essaient de [Faux objectif] alors qu'ils devraient [Vrai objectif]. La question qui a tout changé pour [Prénom client].\n\nPendant [Durée], elle a [Tentative ratée 1], [Tentative ratée 2], [Tentative ratée 3]. Résultat : [Conséquence négative].\n\nLa question que je lui ai posée en première séance : [Question puissante] ?\n\nCette question a réorganisé toute sa [Domaine impacté].\n\nPas plus de [Faux levier]. Plus de [Vrai levier].",
      script_adapted: "La plupart de mes clientes essaient de mieux dormir alors qu'elles devraient apprendre à mieux décrocher. La question qui a tout changé pour Camille.\n\nPendant 8 mois, elle a testé les tisanes, la méditation guidée, les somnifères. Résultat : elle s'endormait à 3h en pleurant.\n\nLa question que je lui ai posée en première séance : qu'est-ce que ton corps essaie de te dire quand tu n'arrives pas à dormir ?\n\nCette question a réorganisé toute sa façon d'aborder ses nuits.\n\nPas plus de discipline. Plus d'écoute.",
      structure: [
        { beat: 1, fonction: 'Hook', texte: 'Affirmation contre-intuitive + promesse de méthode via cas client.' },
        { beat: 2, fonction: 'Contexte', texte: 'Liste des tentatives ratées du client (preuve de la galère).' },
        { beat: 3, fonction: 'Pivot', texte: 'La question puissante qui a tout débloqué.' },
        { beat: 4, fonction: 'Mécanisme', texte: 'Comment cette question recadre tout le problème.' },
        { beat: 5, fonction: 'Punchline', texte: 'Inversion conceptuelle finale (pas plus de X, mais plus de Y).' },
      ],
      why_for_you: "Tu adresses des cadres qui ont déjà tout essayé. Ce format de confession+question puissante installe ton autorité douce sans jamais paraître agressive.",
    },
    {
      format_id: 'mock-2',
      locked: false,
      source: {
        createur: '@matt_gray',
        niche: 'Self-improvement',
        format_nom: 'Témoignage avant/après · b-roll discrets',
        vues: 890_000,
        engagement: 3.8,
        duree_secondes: 52,
        lien: 'https://www.instagram.com/reel/DABC456def/',
        poster_url: null,
        mecanisme_viral: 'Identification',
        arc_narratif: 'Avant → Après',
        emotion_primaire: 'Espoir',
        hook_original: "Six months ago I couldn't speak in front of 5 people. Last week I gave a keynote to 5000. Here's what changed.",
        script_original: "Six months ago I couldn't speak in front of 5 people without my voice shaking.\n\nLast week I gave a keynote to 5000.\n\nWhat changed wasn't confidence. It was three exercises I do every morning.\n\nThe first one takes 90 seconds...",
      },
      hook_template: "Il y a [Délai], [Capacité ratée]. Aujourd'hui [Capacité acquise]. Voilà ce qui a changé.",
      hook_adapted: "Il y a 6 mois, mes clientes mettaient 2h à s'endormir tous les soirs. Aujourd'hui elles dorment en 15 minutes. Voilà ce qui a changé.",
      script_template: "Il y a [Délai], [Audience cible] [Problème quotidien intense].\n\nAujourd'hui [Résultat tangible chiffré].\n\nCe qui a changé ce n'est pas [Faux levier évident]. C'est [Vrai levier inattendu].\n\nLe premier [Outil/exercice] prend [Durée courte]...",
      script_adapted: "Il y a 6 mois, mes clientes cadres mettaient 2h à s'endormir tous les soirs avec le cerveau en boucle.\n\nAujourd'hui elles dorment en 15 minutes maximum.\n\nCe qui a changé ce n'est pas leur discipline. C'est trois ancrages que je leur fais répéter au lit.\n\nLe premier prend 90 secondes...",
      structure: [
        { beat: 1, fonction: 'Hook', texte: 'Contraste temporel fort (avant/après chiffré).' },
        { beat: 2, fonction: 'Tension', texte: 'Le résultat actuel est tangible et vérifiable.' },
        { beat: 3, fonction: 'Pivot', texte: 'Le vrai levier est contre-intuitif (pas la discipline).' },
        { beat: 4, fonction: 'Méthode', texte: 'Le premier outil concret, durée précise.' },
        { beat: 5, fonction: 'CTA', texte: 'Suite implicite (commenter pour la liste complète).' },
      ],
      why_for_you: "Tes clientes ont besoin de preuves. Ce format avant/après chiffré crée l'identification immédiate et l'envie de tester ta méthode.",
    },
    {
      format_id: 'mock-3',
      locked: false,
      source: {
        createur: '@hookpoint',
        niche: 'Content strategy',
        format_nom: 'Liste numérotée · slides texte',
        vues: 312_000,
        engagement: 5.1,
        duree_secondes: 28,
        lien: 'https://www.instagram.com/reel/DDEF789ghi/',
        poster_url: null,
        mecanisme_viral: 'Valeur utile',
        arc_narratif: 'Liste',
        emotion_primaire: 'Curiosité',
        hook_original: 'The 5 mistakes killing your hooks (and nobody is telling you).',
        script_original: "5 mistakes killing your hooks.\n\n1. Starting with 'hey guys'\n2. Announcing what you'll say\n3. Promises without curiosity\n4. Hooks too long\n5. No anchor in real life",
      },
      hook_template: "Les [Chiffre] erreurs qui [Conséquence négative] (et que [Autorité de référence] ne te dit pas).",
      hook_adapted: "Les 5 erreurs qui ruinent ton sommeil (et que ton médecin ne te dit pas).",
      script_template: "[Chiffre] erreurs qui [Conséquence].\n\n1. [Erreur 1 quotidienne]\n2. [Erreur 2 banale]\n3. [Erreur 3 contre-intuitive]\n4. [Erreur 4 spécifique au domaine]\n5. [Erreur 5 finale qui fait mal]\n\nCelle qui te touche le plus en commentaire.",
      script_adapted: "5 erreurs qui ruinent ton sommeil.\n\n1. Regarder ton téléphone au lit en pensant que ça t'aide à décrocher\n2. Te coucher dès que tu te sens fatiguée (tu rates ta fenêtre)\n3. Boire de la tisane après 21h (trop tardif)\n4. Vouloir dormir 8h pile (focus sur la qualité, pas la durée)\n5. Te dire « je dois absolument dormir » (cette phrase t'éveille à chaque fois)\n\nCelle qui te touche le plus en commentaire.",
      structure: [
        { beat: 1, fonction: 'Hook', texte: 'Liste numérotée + curiosity gap (contre une autorité).' },
        { beat: 2, fonction: 'Item 1-2', texte: 'Erreurs banales que tout le monde fait.' },
        { beat: 3, fonction: 'Item 3', texte: "Erreur contre-intuitive qui éduque l'audience." },
        { beat: 4, fonction: 'Item 4-5', texte: 'Erreurs plus pointues pour les avertis.' },
        { beat: 5, fonction: 'CTA', texte: "Invitation à commenter pour engagement (algo + qualification audience)." },
      ],
      why_for_you: "Format ultra share-able. Les 5 erreurs te positionnent comme experte qui démystifie, sans paraître prétentieuse.",
    },
    // === 5 LOCKED ===
    {
      format_id: 'mock-l-1',
      locked: true,
      source: {
        createur: '@grant_cardone',
        niche: 'Business / Mindset',
        format_nom: 'Provocation cadrage serré',
        vues: 540_000,
        duree_secondes: 22,
        lien: 'https://www.instagram.com/reel/DLOCK111/',
        poster_url: null,
        mecanisme_viral: 'Provocation',
        arc_narratif: 'Tension → Révélation',
      },
      hook_template: "Arrête de [Faux conseil mainstream]. C'est ce qui [Conséquence négative] depuis [Délai].",
    },
    {
      format_id: 'mock-l-2',
      locked: true,
      source: {
        createur: '@les_muses',
        niche: 'Confession',
        format_nom: 'Micro-trottoir tabou',
        vues: 1_200_000,
        duree_secondes: 41,
        lien: 'https://www.instagram.com/reel/DLOCK222/',
        poster_url: null,
        mecanisme_viral: 'Polarisation',
        arc_narratif: 'Question → Réponse',
      },
      hook_template: "[Question intime] ? Voilà ce que [N] personnes ont répondu.",
    },
    {
      format_id: 'mock-l-3',
      locked: true,
      source: {
        createur: '@fabien_olicard',
        niche: 'Bien-être',
        format_nom: 'Tutoriel face caméra · sous-titres',
        vues: 890_000,
        duree_secondes: 47,
        lien: 'https://www.instagram.com/reel/DLOCK333/',
        poster_url: null,
        mecanisme_viral: 'Valeur utile',
        arc_narratif: 'Problème → Solution',
      },
      hook_template: "Je ne veux pas me la raconter, mais j'ai la meilleure astuce pour [Résultat désiré] en [Délai court].",
    },
    {
      format_id: 'mock-l-4',
      locked: true,
      source: {
        createur: '@luca_ai',
        niche: 'Développement perso',
        format_nom: 'Infographie texte animée',
        vues: 670_000,
        duree_secondes: 33,
        lien: 'https://www.instagram.com/reel/DLOCK444/',
        poster_url: null,
        mecanisme_viral: 'Identification',
        arc_narratif: 'Énumération',
      },
      hook_template: "Mon mindset a complètement changé quand j'ai compris [Vérité contre-intuitive].",
    },
    {
      format_id: 'mock-l-5',
      locked: true,
      source: {
        createur: '@alextherea',
        niche: 'Croissance',
        format_nom: 'Storytelling brut · b-roll quotidien',
        vues: 1_400_000,
        duree_secondes: 58,
        lien: 'https://www.instagram.com/reel/DLOCK555/',
        poster_url: null,
        mecanisme_viral: 'Inspiration',
        arc_narratif: 'Avant → Après',
      },
      hook_template: "Comment je suis passée de [Point A décourageant] à [Point B aspirationnel] en [Délai] sans [Faux raccourci].",
    },
  ],
}
